import { api } from "@/boot/axios"
import { getAuthToken } from "@/boot/axios"
import type { Event, EventInvite, EventRegistration, EventTicket } from "@/interfaces/event"
import type { ConfirmResponse } from "@/interfaces"
import type { Resident } from "@/interfaces/resident"

export function useEvent() {

  const getEventList = async () => {
    try {
      const response = await api.get<Event[]>('/event/list', {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er) {
      console.error(er)
      return []
    }
  }

  const getEventInvitations = async () => {
    try {
      const response = await api.get<Event[]>('/event/invitations', {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er) {
      console.error(er)
      return []
    }
  }

  const getEventDetail = async (eventId: number) => {
    try {
      const response = await api.get<Event>(`/event/${eventId}`, {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er) {
      console.error(er)
      return er
    }
  }

  const toggleFavouriteEvent = async (eventId: number) => {
    try {
      await api.post(`/event/toggle-favourite/${eventId}`, {}, {
        headers: {
          'Authorization': getAuthToken()
        }
      })
    } catch (er) {
      console.error(er)
    }
  }

  const eventResidents = async (eventId: number) => {
    try {
      const response = await api.get<Resident[]>(`/event/${eventId}/residents`, {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er) {
      console.error(er)
      return []
    }
  }

  const toggleInvite = async (inviteData: EventInvite) => {
    try {
      await api.post('/event/invite', inviteData, {
        headers: {
          'Authorization': getAuthToken()
        }
      })
    } catch (er) {
      console.error(er)
    }
  }

  const toggleRegistration = async (regData: EventRegistration) => {
    try {
      const response = await api.post<ConfirmResponse>('/event/toggle-registration', regData, {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er) {
      console.error(er)
    }
  }

  const getEventTickets = async (eventId: number) => {
    try {
      const response = await api.get<EventTicket[]>(`/event/${eventId}/tickets`, {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er) {
      console.error(er)
      return []
    }
  }

  const controlInvite = async (event_id: number, action: string) => {
    try {
      await api.post(
        '/event/toggle-invite',
        {event_id: event_id, action: action},
        {headers: {'Authorization': getAuthToken()}}
      )
    } catch(er) {
      console.error(er)
    }
  }

  return {
    getEventList,
    getEventInvitations,
    getEventDetail,
    toggleFavouriteEvent,
    eventResidents,
    toggleInvite,
    toggleRegistration,
    getEventTickets,
    controlInvite
  }
}